// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TreeNodeViewModel from "./../factories/tree-node";
import TabController from "./../factories/tab-controller";
import TabPage from "./../factories/tab-page";
import baoDialog from "./../factories/bao-dialog";
import "./../bindings/bao-tree";
import "./../bindings/bao-number-box";
import "./../bindings/bao-tabs";
import "./../bindings/bao-toolbar2";
import "./../bindings/foreach-selection";
import "./../bindings/sorting";
import "./../bindings/bao-pager";
function TicketEscalationDefinitionStepTabViewModel(stepId, parent, tabPage) {
    var self = this;
    self.Bao = Bao;
    self.TitleMessage = Bao.Session.GetMessage("TicketEscalationDefinitionStepTabHeader");
    self.TabTitle = ko.computed(function () {
        var title = self.TitleMessage() + " " + stepId;
        tabPage.Title(title);
        return title;
    });
    self.ToolbarButtons = ko.observableArray([]);
    self.SelectedUsers = ko.observableArray([]);
    self.SelectedUserIds = ko.observableArray([]);
    self.StepId = ko.observable(stepId);
    self.Users = ko.observableArray([]);
    self.PageIndex = ko.observable(0);
    self.PageSize = ko.observable(10);
    self.Sorting = ko.observableArray([]);
    self.TotalRows = ko.observable(0);
    self.Selection = ko.observableArray([]);
    self.Parent = parent;
    self.PageIndex.subscribe(function () {
        self.Refresh();
    });
    self.Sorting.subscribe(function () {
        self.Refresh();
    });
    self.SelectedUserIds.subscribe(function (newValue) {
        self.AddUsers();
    });
    self.Refresh = function () {
        return Bao.post("TicketEscalationDefinition/GetUsers", JSON.stringify({
            pageSize: self.PageSize(),
            pageIndex: self.PageIndex(),
            sorting: self.Sorting(),
            sessionTabId: parent.SessionTabId(),
            stepId: stepId,
            ticketEscalationDefinitionId: parent.TicketEscalationDefinitionId()
        }), function (result) {
            self.TotalRows(result.TotalRows);
            if (result.Models == null) {
                self.Users([]);
            }
            else {
                self.Users(result.Models);
            }
        });
    };
    self.AddUsers = function () {
        var def = $.Deferred();
        Bao.post("TicketEscalationDefinition/AddUsers", JSON.stringify({
            sessionTabId: parent.SessionTabId(),
            stepId: stepId,
            userIds: self.SelectedUserIds(),
            ticketEscalationDefinitionId: parent.TicketEscalationDefinitionId()
        }), function (result) {
            parent.TabPage.DirtyFlag(true);
            self.Refresh().then(def.resolve);
        });
        return def.promise();
    };
    self.RemoveUsers = function () {
        var def = $.Deferred();
        var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgRemoveTicketEscalationStepUsers"), "yesno");
        dialog.DialogResult.subscribe(function (dialogResult) {
            if (dialogResult === true) {
                var ids = [];
                for (var i = 0; i < self.Selection().length; i++) {
                    ids.push(ko.unwrap(self.Selection()[i].TicketEscalationDefinitionUserId));
                }
                Bao.post("TicketEscalationDefinition/RemoveUsers", JSON.stringify({
                    sessionTabId: parent.SessionTabId(),
                    stepId: stepId,
                    ticketEscalationUserIds: ids,
                    ticketEscalationDefinitionId: parent.TicketEscalationDefinitionId()
                }), function (result) {
                    parent.TabPage.DirtyFlag(true);
                    self.Refresh().then(def.resolve);
                });
            }
            else {
                def.resolve();
            }
        });
        return def.promise();
    };
    self.PerformRefresh = function () {
        if (self.PageIndex() == 0) {
            self.Refresh();
        }
        else {
            self.PageIndex(0);
        }
    };
    self.ToolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "TicketEscalationStepUserAdd":
                self.ShowUserSearchDialog();
                break;
            case "TicketEscalationStepUserRemove":
                self.RemoveUsers();
                break;
        }
    };
    self.ShowUserSearchDialog = function () { };
}
function TicketEscalationDefinitionViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.TabViewModel = new TabController(false);
    self.TabPage = tabPage;
    var tabStep1 = new TabPage("Step1");
    var tabStep2 = new TabPage("Step2");
    var tabStep3 = new TabPage("Step3");
    var tabStep4 = new TabPage("Step4");
    var tabStep5 = new TabPage("Step5");
    tabStep1.ViewModel(new TicketEscalationDefinitionStepTabViewModel(1, self, tabStep1));
    tabStep2.ViewModel(new TicketEscalationDefinitionStepTabViewModel(2, self, tabStep2));
    tabStep3.ViewModel(new TicketEscalationDefinitionStepTabViewModel(3, self, tabStep3));
    tabStep4.ViewModel(new TicketEscalationDefinitionStepTabViewModel(4, self, tabStep4));
    tabStep5.ViewModel(new TicketEscalationDefinitionStepTabViewModel(5, self, tabStep5));
    tabStep1.IsClosable(false);
    tabStep2.IsClosable(false);
    tabStep3.IsClosable(false);
    tabStep4.IsClosable(false);
    tabStep5.IsClosable(false);
    tabStep1.Url("TicketEscalationDefinition/StepTab");
    tabStep2.Url("TicketEscalationDefinition/StepTab");
    tabStep3.Url("TicketEscalationDefinition/StepTab");
    ;
    tabStep4.Url("TicketEscalationDefinition/StepTab");
    tabStep5.Url("TicketEscalationDefinition/StepTab");
    self.TabViewModel.AddTab(tabStep1);
    self.TabViewModel.AddTab(tabStep2);
    self.TabViewModel.AddTab(tabStep3);
    self.TabViewModel.AddTab(tabStep4);
    self.TabViewModel.AddTab(tabStep5);
    self.TabViewModel.SelectTab(tabStep1);
    self.CustomerId = ko.observable();
    self.CustomerId.subscribe(function (value) {
        if (value == null) {
            self.LocationId(null);
            self.LocationName("");
            self.AllLocations(true);
            self.LocationEnabled(false);
            self.AllLocationEnabled(false);
        }
        else {
            self.AllLocationEnabled(true);
        }
    });
    self.CustomerName = ko.observable();
    self.CustomerEnabled = ko.observable(true);
    self.AllCustomers = ko.observable();
    self.AllCustomers.subscribe(function (value) {
        if (value == true) {
            self.CustomerId(null);
            self.CustomerName("");
            self.CustomerEnabled(false);
        }
        else {
            self.CustomerEnabled(true);
        }
    });
    self.LocationId = ko.observable();
    self.LocationName = ko.observable();
    self.LocationEnabled = ko.observable(true);
    self.AllLocationEnabled = ko.observable(true);
    self.AllLocations = ko.observable();
    self.AllLocations.subscribe(function (value) {
        if (value == true) {
            self.LocationId(null);
            self.LocationName("");
            self.LocationEnabled(false);
        }
        else {
            self.LocationEnabled(true);
        }
    });
    self.TicketPriorityId = ko.observable();
    self.TicketPriorityName = ko.observable();
    self.TicketPriorityEnabled = ko.observable(true);
    self.AllTicketPriorities = ko.observable();
    self.AllTicketPriorities.subscribe(function (value) {
        if (value == true) {
            self.TicketPriorityId(null);
            self.TicketPriorityName("");
            self.TicketPriorityEnabled(false);
        }
        else {
            self.TicketPriorityEnabled(true);
        }
    });
    self.ServiceProviderId = ko.observable();
    self.ServiceProviderName = ko.observable();
    self.ServiceProviderEnabled = ko.observable(true);
    self.AllServiceProviders = ko.observable();
    self.AllServiceProviders.subscribe(function (value) {
        if (value == true) {
            self.ServiceProviderId(null);
            self.ServiceProviderName("");
            self.ServiceProviderEnabled(false);
        }
        else {
            self.ServiceProviderEnabled(true);
        }
    });
    self.DeleteService = function () {
        self.TicketServiceStructureName(null);
        self.TicketServiceStructureId(null);
    };
    self.SelectService = function () {
        tabPage.IsLoading(true);
        Bao.post("Ticket/GetTreeDialogDataSource", JSON.stringify({
            type: "TicketService"
        }), function (value) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            var dialogViewModel : any = {};
            dialogViewModel.NodeToggled = function () {
                dialog.SetPosition();
            };
            var dataSource = [];
            for (var i = 0; i < value.nodes.length; i++) {
                dataSource.push(new TreeNodeViewModel(value.nodes[i]));
            }
            dialogViewModel.Nodes = ko.observableArray(dataSource);
            dialogViewModel.SelectedService = ko.observable();
            dialogViewModel.SelectedService.subscribe(function () {
                dialogViewModel.okClick();
            });
            dialogViewModel.okClick = function () {
                tabPage.IsLoading(true);
                var selectedNode;
                selectedNode = dialogViewModel.SelectedService();
                if (selectedNode != null) {
                    if (selectedNode.IsAllowed()) {
                        return Bao.post("Ticket/GetTicketServiceStructure", JSON.stringify({
                            selectedTicketServiceId: selectedNode.Id()
                        }), function (result) {
                            self.InitializeDataBindingTicketServiceStructure(result.TicketServiceStructureId);
                            self.TicketServiceStructureId(result.TicketServiceStructureId);
                            dialog.Close();
                            tabPage.IsLoading(false);
                        });
                    }
                }
                tabPage.IsLoading(false);
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("TicketServiceInvalidSelection"), "info");
                return null;
            };
            dialog.Width(500);
            dialog.ViewModel(dialogViewModel);
            dialog.Template(value.Message);
            dialog.Buttons([{
                    Title: Bao.Session.GetMessage("msgOk"),
                    Enabled: ko.observable(true),
                    Click: dialogViewModel.okClick
                }]);
            dialog.Open();
            tabPage.IsLoading(false);
            dialog.SetPosition();
        });
    };
    self.InitializeDataBindingTicketServiceStructure = function (id) {
        return Bao.post("Ticket/GetCompleteTicketServiceStructure", JSON.stringify({
            id: id
        }), function (value) {
            self.TicketServiceStructureName(value);
        });
    };
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Name()) || self.HolidaySchemaId == null || self.WorkingTimeSchemaId == null) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.CheckCustomer = function () {
        if (self.CustomerId() == null) {
            self.AllCustomers(true);
        }
    };
    self.CheckLocation = function () {
        if (self.LocationId() == null) {
            self.AllLocations(true);
        }
    };
    self.CheckTicketPriority = function () {
        if (self.TicketPriorityId() == null) {
            self.AllTicketPriorities(true);
        }
    };
    self.CheckServiceProvider = function () {
        if (self.ServiceProviderId() == null) {
            self.AllServiceProviders(true);
        }
    };
    var baseRefresh = self.PerformRefresh;
    self.PerformRefresh = function () {
        baseRefresh.call(self).then(function () {
            self.RefreshStepTabs();
            self.CheckCustomer();
            self.CheckLocation();
            self.CheckTicketPriority();
            self.CheckServiceProvider();
        });
    };
    self.RefreshStepTabs = function () {
        tabStep1.ViewModel().PerformRefresh();
        tabStep2.ViewModel().PerformRefresh();
        tabStep3.ViewModel().PerformRefresh();
        tabStep4.ViewModel().PerformRefresh();
        tabStep5.ViewModel().PerformRefresh();
    };
    var baseLoaded = self.loaded;
    self.loaded = function () {
        self.RefreshStepTabs();
        baseLoaded.call(self);
        self.CheckCustomer();
        self.CheckLocation();
        self.CheckTicketPriority();
        self.CheckServiceProvider();
    };
}
Bao.inherit(TicketEscalationDefinitionViewModel, SearchPaging);
TicketEscalationDefinitionViewModel.prototype.PrimaryKey = "TicketEscalationDefinitionId";
TicketEscalationDefinitionViewModel.prototype.RefreshUrl = "TicketEscalationDefinition/Get";
TicketEscalationDefinitionViewModel.prototype.SaveUrl = "TicketEscalationDefinition/Save";
TicketEscalationDefinitionViewModel.prototype.DeleteUrl = "TicketEscalationDefinition/Delete";
TicketEscalationDefinitionViewModel.prototype.IsInUseUrl = "TicketEscalationDefinition/IsInUse";
TicketEscalationDefinitionViewModel.prototype.PermissionForward = "TicketEscalationDefinitionMoveForwardSearch";
TicketEscalationDefinitionViewModel.prototype.PermissionBackward = "TicketEscalationDefinitionMoveBackwardSearch";
TicketEscalationDefinitionViewModel.prototype.PermissionSave = "TicketEscalationDefinitionSave";
TicketEscalationDefinitionViewModel.prototype.PermissionRefresh = "TicketEscalationDefinitionRefresh";
TicketEscalationDefinitionViewModel.prototype.PermissionDelete = "TicketEscalationDefinitionDelete";
export default TicketEscalationDefinitionViewModel;